import { useEffect, useState } from "react";
import "../../../assets/css/repaymentUpload.css";

import BaseModal from "../../../components/BaseModal";
import AppToast from "../../../components/AppToast";

const LOAN_SETTINGS_API = `${process.env.REACT_APP_API_BASE}/loans/loan_settings.php`;

export default function RepaymentUpload() {
  const [file, setFile] = useState(null);
  const [product, setProduct] = useState("");
  

  const [loanProducts, setLoanProducts] = useState([]);
  const [uploads, setUploads] = useState([]);
  const [selectedUpload, setSelectedUpload] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [toast, setToast] = useState(null);


const fetchLoanProducts = async () => {
  try {
    const res = await fetch(LOAN_SETTINGS_API, {
      method: "GET",
      credentials: "include",
    });

    const data = await res.json();

    if (data.success) {
      setLoanProducts(data.products || []);
    }
  } catch (err) {
    console.error("Fetch loan products error:", err);
  }
};

  const fetchUploads = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/repayment_uploads.php`,
        { credentials: "include" }
      );
      const data = await res.json();
      if (data.success) setUploads(data.uploads || []);
    } catch (err) {
      console.error("Fetch uploads error:", err);
    }
  };

  const viewUpload = async (upload) => {
  setSelectedUpload(upload);
  setRows([]);
  setShowDetailsModal(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/repayment_upload_details.php?upload_id=${upload.id}`,
        { credentials: "include" }
      );
      const data = await res.json();
      if (data.success) setRows(data.rows || []);
    } catch (err) {
      console.error("Fetch upload rows error:", err);
    }
  };


const downloadTemplate = () => {
  const csvContent =
    "ASSIGNMENT_NUMBER,FULL_NAME,REPAYMENT_AMOUNT\nIPPIS-778899,Pelumi Emmanuel,100000";

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "repayment_upload_template.csv";
  link.click();

  URL.revokeObjectURL(url);
};

  const handleUpload = async () => {
    if (!file || !product) {
    setToast({
  type: "error",
  title: "Missing Information",
  message: "Please select product and repayment file.",
});
      return;
    }

    const formData = new FormData();
    formData.append("repayment_file", file);
    formData.append("product", product);

    try {
      setLoading(true);

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/upload_repayment.php`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        }
      );

      const data = await res.json();

     if (!data.success) {
setToast({
  type: "error",
  title: "Upload Failed",
message: data.message || "Upload failed. Please check file format.",
});
  return;
}

   setToast({
  type: "success",
  title: "Upload Successful",
  message: "Repayment uploaded successfully.",
});

setShowConfirmModal(false);
setFile(null);
setProduct("");
fetchUploads();
    } catch (err) {
      console.error("Upload error:", err);
    setToast({
  type: "error",
  title: "Network Error",
  message: "Unable to upload repayment file. Please try again.",
});
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  fetchUploads();
  fetchLoanProducts();
}, []);

  return (
    <div className="repayment-page">
      <div className="repayment-hero-card">
        <div className="repayment-hero-top">
          <div>
            <span className="repayment-badge">Loan Operations</span>
            <h2>Repayment Schedule Upload</h2>
            <p>
              Upload monthly repayment schedules and match repayments using
              IPPIS / Assignment Number.
            </p>
          </div>

          <div className="repayment-icon">
            <i className="fa fa-upload" />
          </div>
        </div>

        <div className="repayment-format-box">
          <i className="fa fa-info-circle" />
          <span>
            Expected columns:
            <strong> ASSIGNMENT_NUMBER, FULL_NAME, REPAYMENT_AMOUNT</strong>
          </span>
        </div>

<div className="repayment-template-row">
  <button
    type="button"
    className="repayment-template-btn"
    onClick={downloadTemplate}
  >
    <i className="fa fa-download" />
    Download CSV Template
  </button>
</div>

        <div className="repayment-upload-grid">
          <div>
            <label className="form-label fw-semibold">Loan Product</label>
            <select
              className="form-control repayment-input"
              value={product}
              onChange={(e) => setProduct(e.target.value)}
            >
             <option value="">Select Product</option>

{loanProducts.map((item: any) => (
<option key={item.product_name} value={item.product_name}>
  {item.product_name.replace(/_/g, " ")}
</option>
))}
            </select>
          </div>

          <div>
            <label className="form-label fw-semibold">Repayment File</label>
            <input
              type="file"
              className="form-control repayment-input"
             accept=".csv"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </div>
        </div>

        {file && (
          <div className="selected-file-box">
            <i className="fa fa-file-excel" />
            <span>{file.name}</span>
          </div>
        )}

        <div className="repayment-actions">
          <button
            className="repayment-primary-btn"
            disabled={!file || !product || loading}
            onClick={() => setShowConfirmModal(true)}
          >
          {loading ? (
  <>
    <i className="fa fa-spinner fa-spin me-2"></i>
    Uploading...
  </>
) : (
  "Upload Repayment"
)}
          </button>
        </div>
      </div>

      <div className="repayment-table-card">
        <div className="repayment-table-header">
          <div>
            <h5>Uploaded Repayments</h5>
            <p>View all repayment batches uploaded into the system.</p>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table repayment-table align-middle">
            <thead>
              <tr>
                <th>Upload ID</th>
                <th>Product</th>
                <th>File Name</th>
                <th>Uploaded By</th>
                <th>Date</th>
                <th>Total Rows</th>
                <th>Matched</th>
                <th>Failed</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {uploads.length === 0 ? (
                <tr>
                <td colSpan={9} className="text-center py-5">
  <div style={{ opacity: 0.6 }}>
    <i className="fa fa-database mb-2" style={{ fontSize: 28 }}></i>
    <div>No repayment uploads yet</div>
    <small>Uploaded batches will appear here</small>
  </div>
</td>
                </tr>
              ) : (
                uploads.map((upload) => (
                  <tr key={upload.id}>
                    <td>#{upload.id}</td>
                    <td>{upload.product}</td>
                    <td>{upload.file_name}</td>
                    <td>{upload.uploaded_by}</td>
                   <td>
  {new Date(upload.created_at).toLocaleString("en-NG", {
    dateStyle: "medium",
    timeStyle: "short",
  })}
</td>
                    <td>{upload.total_rows}</td>
                    <td className="text-success fw-bold">
                      {upload.matched_rows}
                    </td>
                    <td className="text-danger fw-bold">
                      {upload.failed_rows}
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-light border"
                        onClick={() => viewUpload(upload)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

    


      <BaseModal
  isOpen={showDetailsModal}
  title={selectedUpload ? `Upload Details #${selectedUpload.id}` : "Upload Details"}
  onClose={() => setShowDetailsModal(false)}
  size="xl"
>
  <p style={{ marginTop: 0, color: "#64748b" }}>
    Repayment matching result for this upload batch.
  </p>

  <div className="table-responsive">
    <table className="table repayment-table align-middle">
      <thead>
        <tr>
          <th>Assignment No</th>
          <th>Full Name</th>
          <th>Amount</th>
          <th>Loan Account</th>
          <th>Status</th>
          <th>Message</th>
        </tr>
      </thead>

      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={6} className="text-center text-muted py-4">
              No rows found.
            </td>
          </tr>
        ) : (
          rows.map((row) => (
            <tr key={row.id}>
              <td>{row.assignment_number}</td>
              <td>{row.full_name}</td>
              <td>₦{Number(row.amount || 0).toLocaleString()}</td>
              <td>{row.loan_account || "-"}</td>
              <td>
                <span
                  className={`badge ${
                    row.status === "MATCHED" ? "bg-success" : "bg-danger"
                  }`}
                >
                  {row.status}
                </span>
              </td>
              <td>{row.message}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</BaseModal>


<AppToast toast={toast} onClose={() => setToast(null)} />


      <BaseModal
  isOpen={showConfirmModal}
  title="Confirm Upload"
  onClose={() => setShowConfirmModal(false)}
  size="sm"
  footer={
    <>
    <button
  className="btn btn-light border"
  disabled={loading}
  onClick={() => setShowConfirmModal(false)}
>
  Cancel
</button>

    <button
  type="button"
  className="btn btn-primary"
  disabled={loading}
onClick={async () => {
  await handleUpload();
}}
>
  {loading ? "Uploading..." : "Confirm Upload"}
</button>
    </>
  }
>
  <p style={{ marginBottom: 0 }}>
    Are you sure you want to upload this repayment file?
  </p>

  <div style={{ marginTop: 10, fontSize: 13, opacity: 0.7 }}>
    <strong>Product:</strong> {product || "-"} <br />
    <strong>File:</strong> {file?.name || "-"}
  </div>
</BaseModal>

    </div>
  );
}